import { useState, useEffect } from 'react'
import { Container, Grid, TextField, Button, Typography, createTheme, Box, Link } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import AppAppBar2 from '../components/AppBar2'
import ProductHeroLayout from '../components/ProductHeroLayout';
import ViewSessionDates from '../components/ViewSessionDates'
import { useOnMount } from '@mui/x-data-grid/internals';

export default function Sessions() {

    const images = ['../img/Student2.jpg', '../img/Student6.jpg', '../img/Student4.jpg', '../img/Student3.jpg', '../img/Student5.jpg', '../img/Student1.jpg'];


    const [backgroundImage, setBackgroundImage] = useState('../img/Student6.jpg')



    const navigate = useNavigate()

    const [catId, setCatId] = useState(2)


    const month = new Date().getMonth()

    var thisYear = ''
    if (month >= 8) {
        thisYear = new Date().getFullYear() + 1
    } else {
        thisYear = new Date().getFullYear()
    }





    return (

        <>
            <AppAppBar2 />
            <ProductHeroLayout
                fullWidth
                sxBackground={{
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundColor: '#7fc7d9', // Average color of the background image.
                    fullWidth: '90vh',
                    transition: 'background 3s linear',
                }}
            >



                <Container maxWidth="lg" disableGutters align="center" top="50%" sx={{ maxHeight: '90vh', backgroundColor: 'white', opacity: '0.8', border: 'Solid', borderWidth: '5px', borderColor: 'primary.main', padding: '30px', borderRadius: 3, marginTop: 3 }}>


                    <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }} sx={{ border: 'solid', borderWidth: '0px', borderColor: 'primary.main', borderRadius: 2 }} >

                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >
                                <Typography variant="h3" component="h3" color="primary.main" sx={{ textAlign: 'center' }}>
                                    Active Examination Sessions
                                </Typography>



                            </Box>


                        </Grid>
                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >
                                <Typography variant="body2" component="p" color="primary.main" sx={{ textAlign: 'center' }}>
                                    See below list of session entry, end and penalty dates for each qualification.
                                </Typography>



                            </Box>


                        </Grid>


                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >
                                <Typography variant="body2" component="p" color="primary.main" sx={{ textAlign: 'center' }}>
                                    <i>   * Dates are subject to change.</i>
                                </Typography>



                            </Box>


                        </Grid>
                        <Grid item xs={12} minWidth={0}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >

                                <ViewSessionDates />



                            </Box>


                        </Grid>
                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >
                                <Typography variant="body2" component="p" color="primary.main" sx={{ textAlign: 'center' }}>
                                    To process an entry, register a candidate account, login and process your entry online.
                                </Typography>



                            </Box>


                        </Grid>



                    </Grid>

                </Container>
            </ProductHeroLayout >
        </>
    )
}
